import { compose } from 'redux';
import { connect } from 'react-redux';
import withFormValidation from 'app/HOC/withFormValidation';
import paymentModule from 'app/store/payment';
import EmailConfirmation from './EmailConfirmation.component';
import schema from './EmailConfirmation.schema';

const { buyRequest, buyWithGiftRequest, applyGiftcardRequest } = paymentModule.actions;

const mapStateToProps = ({ order }) => ({
  userSessionId: order ? order.userSessionId : null
});

const mapDispatchToProps = {
  send: buyRequest,
  buyWithGift: buyWithGiftRequest,
  applyGiftcard: applyGiftcardRequest
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withFormValidation(schema)
)(EmailConfirmation);
